import * as React from "react";
import {toast, ToastContainer} from "react-toastify";
import {Outlet} from "react-router";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import 'react-toastify/dist/ReactToastify.css';
import {useAuth} from "../providers/auth";
import Loading from "../components/loading";
import {gql} from "@apollo/client";
import {query} from "../lib/apollo";

const theme = createTheme();

function hasPendingSso(): boolean {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("client_id") && urlParams.get("redirect_url")) {
        return true;
    }
    return !!(localStorage.getItem("client_id") && localStorage.getItem("redirect_url"));
}

export default function Layout() {
    const auth = useAuth();
    const [ssoPending, setSsoPending] = React.useState(hasPendingSso);

    React.useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const clientId = urlParams.get("client_id");
        const redirectUrl = urlParams.get("redirect_url");
        if (clientId && redirectUrl) {
            localStorage.setItem("client_id", clientId);
            localStorage.setItem("redirect_url", redirectUrl);
            setSsoPending(true);
        }
    }, []);

    React.useEffect(() => {
        if (auth.loading || !auth.user || !ssoPending) {
            return;
        }

        const clientId = localStorage.getItem("client_id");
        const redirectUrl = localStorage.getItem("redirect_url");
        if (!clientId || !redirectUrl) {
            setSsoPending(false);
            return;
        }

        const q = gql`
            query Query($clientId: String!) {
                ssoLogin(client_id: $clientId)
            }
        `;

        let cancelled = false;
        query(q, {clientId}).then((result) => {
            if (cancelled) {
                return;
            }
            if (result?.ssoLogin) {
                localStorage.removeItem("client_id");
                localStorage.removeItem("redirect_url");
                const param = redirectUrl.includes("?") ? "&" : "?";
                window.location.href = `${redirectUrl}${param}access_token=${result.ssoLogin}`;
                return;
            }
            setSsoPending(false);
        });

        return () => {
            cancelled = true;
        };
    }, [auth.loading, auth.user, ssoPending]);

    if (auth.loading || (auth.user && ssoPending)) {
        return <Loading />;
    }

    return (
        <ThemeProvider theme={theme}>
            <Outlet />
            <p></p>
            <ToastContainer position={toast.POSITION.TOP_CENTER} />
        </ThemeProvider>
    );
}
